import { createContext } from 'react';

const calculatorsContext = createContext();

export default calculatorsContext;
